import {Reducer} from "redux";
import {PledgerAction} from "@pledger/frontend-commons";
import {NavigationMenuActions} from "./NavigationMenuActions";
import {ShowPageActions} from "../../../ui/app/Pages/ShowPageActions";
import {AppActions} from "../../../ui/app/AppActions";
import {NavigationMenuItemId} from "./DistributorNavigationMenuComponent";

const displayUserMenu : Reducer  = (state  = false, action: PledgerAction) => {
    switch (action.type) {
        case NavigationMenuActions.NAVIGATION_MENU_DISPLAY_USER_MENU_ACTION.type:
            return !state;

            case ShowPageActions.SHOW_ACCOUNT_ACTION.type:
            return false;

        case AppActions.DISCONNECT_ACTION.type:
            return false;

        case AppActions.CLOSE_ALL_DROPDOWN_ACTION.type:
            return false;

        default:
            return state;
    }
};

const selectedMenuItemId : Reducer  = (state = NavigationMenuItemId.ACCUEIL, action: PledgerAction) => {
    switch (action.type) {
        case NavigationMenuActions.NAVIGATION_MENU_SELECT_MENU_ITEM_ACTION.type:
            return action.payload.menuItemId;

        default:
            return state;
    }
};

export interface NavigationMenuState {
    displayUserMenu: boolean;
    selectedMenuItemId: NavigationMenuItemId;
}

export const navigationMenu : Reducer = (state={},action) => {
    return {
        displayUserMenu: displayUserMenu(state.displayUserMenu, action),
        selectedMenuItemId: selectedMenuItemId(state.selectedMenuItemId, action),
    }
}
